import {
  DELETE_MIXINGPLANT_REQUEST,
  DELETE_MIXINGPLANT_ERROR,
  DELETE_MIXINGPLANT_SUCCESS,
  TOKEN_EXPIRED
} from '../types';
import context from "../common/deleteEntity"
import RESOURCES from '../../api/resources';

const initialState = {};
export default entity => async (state = initialState, action) => {

  context.init(context);

  context.DELETE_ENTITY_REQUEST = DELETE_MIXINGPLANT_REQUEST;
  context.DELETE_ENTITY_ERROR = DELETE_MIXINGPLANT_ERROR;
  context.DELETE_ENTITY_SUCCESS = DELETE_MIXINGPLANT_SUCCESS;
  context.TOKEN_EXPIRED = TOKEN_EXPIRED;

  context.entityName = "mixingPlant";
  context.entityLocation = RESOURCES.MixingPlants;

  return context.execute(context)(entity)(state, action);
};

